import { render, staticRenderFns } from "./bookingtable.vue?vue&type=template&id=5cb12a1a&scoped=true&"
import script from "./bookingtable.vue?vue&type=script&lang=js&"
export * from "./bookingtable.vue?vue&type=script&lang=js&"
import style0 from "./bookingtable.vue?vue&type=style&index=0&id=5cb12a1a&prod&scoped=true&lang=scss&"
import style1 from "./bookingtable.vue?vue&type=style&index=1&id=5cb12a1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb12a1a",
  null
  
)

export default component.exports